import { api, LightningElement } from "lwc";
import { MenuOption } from "tds/userMenu";

import { createTrack, TrackEvent } from "common/track";

import type { UserProfile } from "./types";
export type { UserProfile };

export default class extends LightningElement {
  @api user: UserProfile = undefined!;
  @api userDescription: string = "";

  private track = createTrack<"tds-header-profile">(this);

  private get menuOptions(): MenuOption[] {
    return this.user.navItems.map((item) => ({
      ...item.link,
      label: item.label,
    }));
  }

  private onSummaryClick() {
    this.track("menu_opened", undefined);
  }

  private onUserMenuTrack(e: TrackEvent<"tds-user-menu">) {
    this.track(e.detail.eventName, e.detail.payload);
  }
}
